import { render, staticRenderFns } from "./CreditNoteDocumentPopUp.vue?vue&type=template&id=4b644b9d&scoped=true&"
import script from "./CreditNoteDocumentPopUp.vue?vue&type=script&lang=js&"
export * from "./CreditNoteDocumentPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreditNoteDocumentPopUp.vue?vue&type=style&index=0&id=4b644b9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b644b9d",
  null
  
)

export default component.exports